'use strict';

export default function useThemesSupported(language) {

    return !language || language === 'English';
}
